import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../../constants/common'
import { FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION } from '../../../constants/form'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../constants/pagination'
import { SIZE } from '../../../constants/size'
import { useNotification } from '../../../hooks'
import { getItemsIds } from '../../../utils/common'
import { getCategoriesNG, toCategorySelectItems } from '../../Category'
import { FormModal } from '../../Form'

import {
  USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES,
  USER_EDIT_CATEGORIES_MODAL_QA_NAME,
} from './UserEditCategoriesModal.constants'
import {
  getUserEditCategoriesModalActionTypes,
  getUserEditCategoriesModalInitialValues,
  getUserEditCategoriesModalValidationSchema,
} from './UserEditCategoriesModal.utils'
import { UserEditCategoriesModalFields } from './UserEditCategoriesModalFields'

function UserEditCategoriesModal({ scopeId, onClose, onSubmit }) {
  const { handleAddErrorNotification } = useNotification()

  const [initialValues, setInitialValues] = useState(
    getUserEditCategoriesModalInitialValues(EMPTY_LIST)
  )
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    getCategoriesNG({
      size: PAGINATION_ALL_ITEMS_SIZE,
      staff_member: scopeId,
    })
      .then(({ data }) => {
        setInitialValues(
          getUserEditCategoriesModalInitialValues(
            toCategorySelectItems(data.items)
          )
        )
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [scopeId])

  function handleSubmit({ values }) {
    onSubmit({
      categoryIds: getItemsIds(
        values[USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES],
        'value'
      ),
    })
  }

  return (
    <FormModal
      Fields={UserEditCategoriesModalFields}
      containerProps={{
        boxSize: SIZE.MEDIUM,
        qaName: USER_EDIT_CATEGORIES_MODAL_QA_NAME,
      }}
      formBodyProps={FORM_MODAL_BODY_PROPS_REQUIRED_ENTITY_ACTION}
      formFieldsProps={{
        actionTypes: getUserEditCategoriesModalActionTypes(),
        isLoading,
      }}
      formTitle='Modal.EditCategoryTitleKey'
      initialValues={initialValues}
      validationSchema={getUserEditCategoriesModalValidationSchema(
        initialValues
      )}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default UserEditCategoriesModal
